import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/core/models/api-response';
import { getTenantId } from 'src/app/services/store-snapshot.service';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { environment } from 'src/environments/environment';
import {
  ICustomPropertyDefinition,
  ICustomPropertyDefinitionCreate,
  ICustomPropertyDefinitionUpdate,
  ICustomPropertyResponse,
} from '../../models/custom-property/custom-property.model';

const headers = { 'content-type': 'application/json' };

@Injectable({
  providedIn: 'root',
})
export class CustomPropertyApiService {
  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/CustomPropertyDefinitions`;
  }

  constructor(private http: HttpClient) {}

  loadCustomProperties(
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<ICustomPropertyDefinition[]>> {
    let params = createFilterParams(currentFilter);

    if (currentFilter?.additional?.includeDeleted) {
      params = params.set('IncludeDeleted', currentFilter.additional.includeDeleted);
    }

    return this.http.get<ApiResponse<ICustomPropertyDefinition[]>>(this.url, { params });
  }

  loadCustomPropertyById(id: string): Observable<ICustomPropertyResponse> {
    const url = `${this.url}/${id}`;
    return this.http.get<ICustomPropertyResponse>(url);
  }

  loadCustomPropertyByVersion(id: string, versionId: string): Observable<ICustomPropertyResponse> {
    const url = `${this.url}/${id}/Log/${versionId}`;
    return this.http.get<ICustomPropertyResponse>(url);
  }

  createCustomProperty(
    customProperty: ICustomPropertyDefinitionCreate
  ): Observable<ICustomPropertyDefinition> {
    return this.http.post<ICustomPropertyDefinition>(this.url, customProperty, { headers });
  }

  updateCustomProperty(
    customProperty: ICustomPropertyDefinitionUpdate
  ): Observable<ICustomPropertyDefinition> {
    const url = `${this.url}/${customProperty.id}`;
    return this.http.put<ICustomPropertyDefinition>(url, customProperty, { headers });
  }

  deleteCustomProperty(id: string): Observable<void> {
    const url = `${this.url}/${id}`;
    return this.http.delete<void>(url);
  }

  restoreCustomProperty(id: string): Observable<void> {
    const url = `${this.url}/${id}/Restore`;
    return this.http.put<void>(url, {});
  }
}
